export const sendWhatsapp = (phone: string) => {
  const whatsappUrl = `https://wa.me/${phone.replace(/\D/g, '')}`

  window.open(whatsappUrl, '_blank')
}
